(() => {
  const selector = '[data-cj-aud-cents]';
  const cacheKey = 'carryjoys.usd-aud-reference.v1';
  const maxAge = 24 * 60 * 60 * 1000;
  const formatter = new Intl.NumberFormat('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  let rate = null;
  let started = false;

  const validRate = value => Number.isFinite(value) && value > 0 && value < 100;
  const render = element => {
    if (rate === null) return;
    const raw = element.dataset.cjAudCents;
    const cents = Number(raw);
    if (!raw || !Number.isFinite(cents) || cents < 0) {
      element.hidden = true;
      return;
    }
    const amount = 'A$' + formatter.format(cents / 100 * rate);
    const template = element.dataset.cjAudTemplate;
    if (!template || !template.includes('__AMOUNT__')) return;
    const text = template.replace('__AMOUNT__', amount);
    if (element.textContent !== text) element.textContent = text;
    element.hidden = false;
  };

  const refresh = () => document.querySelectorAll(selector).forEach(render);
  const loadRate = async () => {
    if (started) return;
    started = true;
    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey));
      const age = Date.now() - cached?.fetchedAt;
      if (validRate(cached?.rate) && age >= 0 && age < maxAge) {
        rate = cached.rate;
        refresh();
        return;
      }
    } catch {}
    try {
      const response = await fetch('https://cdn.shopify.com/s/javascripts/currencies.js', {
        credentials: 'omit',
        signal: AbortSignal.timeout(7000)
      });
      if (!response.ok) return;
      const data = await response.text();
      const usd = Number(data.match(/\bUSD:\s*([\d.eE+-]+)/)?.[1]);
      const aud = Number(data.match(/\bAUD:\s*([\d.eE+-]+)/)?.[1]);
      if (!validRate(usd) || !validRate(aud) || !validRate(usd / aud)) return;
      rate = usd / aud;
      try { localStorage.setItem(cacheKey, JSON.stringify({ rate, fetchedAt: Date.now() })); } catch {}
      refresh();
    } catch {}
  };

  const visit = node => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    const elements = [...node.querySelectorAll(selector)];
    if (node.matches(selector)) elements.unshift(node);
    if (!elements.length) return;
    elements.forEach(render);
    void loadRate();
  };

  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') render(record.target);
      else record.addedNodes.forEach(visit);
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cj-aud-cents'] });
  visit(document.body);
})();
